<script setup lang="ts">
import { session } from '../supabase';
import AppSettingsDropDown from './AppSettingsDropDown.vue';
</script>

<template>
  <AppSettingsDropDown v-if="session" />
</template>
